import { DataCollectionEventNames } from '@jarvis/jweb-core';
import { publishSimpleUIEvent } from './jweb';

import { EVENT_SCHEMA_VERSION, SIMPLE_UI_CATEGORY, SIMPLE_UI_GUN } from './constants';

export const sendSimpleUiEvent = event => {
  console.log('dataCollection::sendSimpleUiEvent: %o', event);
  try {
    const cdmEvent = {
      dateTime: new Date().toISOString(),
      eventDetailType: SIMPLE_UI_GUN,
      eventCategory: SIMPLE_UI_CATEGORY,
      version: EVENT_SCHEMA_VERSION,
      eventDetail: event.eventData
    };
    const eventData = {
      events: [cdmEvent],
      valveControllerMetadata: event.metaData
    };
    publishSimpleUIEvent(DataCollectionEventNames.cdmEvent, eventData);
  } catch (error) {
    console.error('dataCollection::sendSimpleUiEvent: %o', error);
  }
};
